import React, { Component } from 'react';
import { l10n } from '../../../i18n/Localization';
import Sc2Character from '../../../models/characters/Sc2Character';

class EditSc2CharacterView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            invalidMsgForIdentificationName: null,
            invalidMsgForProfileUrl: null,
        };

        this.cachedSc2Character = Sc2Character.deserialize(Sc2Character.serialize(props.sc2Character));

        this.refIdentificationName = React.createRef();
        this.refProfileUrl = React.createRef();
    }

    validateIdentificationName() {
        const identificationName = this.refIdentificationName.current.value;
        const exp = new RegExp(/^[a-zA-Z][a-zA-Z0-9]{2,11}$/);

        if (exp.test(identificationName)) {
            return null;
        } else {
            return l10n.editSc2CharacterView.identificationNameInvalid;
        }
    }

    validateProfileUrl() {
        const profileUrl = this.refProfileUrl.current.value;
        const exp = new RegExp(/^https:\/\/starcraft2\.com\/([a-zA-Z]{2}-[a-zA-Z]{2}\/)?profile\/[1235]\/[12]\/\d+/);

        if (exp.test(profileUrl)) {
            return null;
        } else {
            return l10n.editSc2CharacterView.profileUrlInvalid;
        }
    }

    validate() {
        const invalidMsgForIdentificationName = this.validateIdentificationName();
        const invalidMsgForProfileUrl = this.validateProfileUrl();

        this.setState({
            invalidMsgForIdentificationName: invalidMsgForIdentificationName,
            invalidMsgForProfileUrl: invalidMsgForProfileUrl,
        });

        if (invalidMsgForIdentificationName === null && invalidMsgForProfileUrl === null) {
            return true;
        } else {
            return false;
        }
    }

    saveIdentificationName() {
        const identificationName = this.refIdentificationName.current.value;
        this.cachedSc2Character.identificationName = identificationName;
    }

    saveProfileUrl() {
        const profileUrl = this.refProfileUrl.current.value;
        this.cachedSc2Character.profileUrl = profileUrl;
    }

    save() {
        this.saveIdentificationName();
        this.saveProfileUrl();

        return this.cachedSc2Character;
    }

    render() {
        const disabled = this.props.disabled;
        const invalidMsgForIdentificationName = this.state.invalidMsgForIdentificationName;
        const invalidMsgForProfileUrl = this.state.invalidMsgForProfileUrl;

        return (
            <div>
                <input className="form-control mb-1" type="text" id="identificationName" placeholder={l10n.editSc2CharacterView.identificationName} defaultValue={this.cachedSc2Character.identificationName} ref={this.refIdentificationName} disabled={disabled} />
                <div className="text-danger mb-3">{invalidMsgForIdentificationName !== null ? invalidMsgForIdentificationName : null}</div>
                <input className="form-control mb-1" type="text" id="profileUrl" placeholder={l10n.editSc2CharacterView.profileUrl} defaultValue={this.cachedSc2Character.profileUrl} ref={this.refProfileUrl} disabled={disabled || (this.cachedSc2Character.id !== null)} />
                <div className="text-success mb-1">{this.cachedSc2Character.id === null ? l10n.editSc2CharacterView.profileUrlUnchangeableLater: l10n.editSc2CharacterView.profileUrlUnchangeable}</div>
                <div className="text-danger mb-3">{invalidMsgForProfileUrl !== null ? invalidMsgForProfileUrl : null}</div>
            </div>
        );
    }
}

export default EditSc2CharacterView;
